<!--
 * @Description: 
 * @Date: 2020-09-25 10:48:46
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="reward-log-list" @touchmove="preLoad($event)">
    <list v-bind="$data" defaultText="抱歉，暂无内容呦~" defaultMid>
     <div class="item" v-for="(item,index) in listData" :key="index">
        <div class="reward-name">{{item.prizeName}}</div>
        <div class="group">
          <div class="cell">
            <span>活动名称</span>
            <span>{{item.activityTitle}}</span>
          </div>
          <div class="cell">
            <span>中奖时间</span>
            <span>{{dateFormat(item.bestAchievementDt)}}</span>
          </div>
          <div class="cell">
            <span>发货状态</span>
            <span>{{item.isSend==1?'已发货':'未发货'}}</span>
          </div>
          <template v-if="item.isSend==1">
            <div class="cell">
              <span>快递公司</span>
              <span>{{item.courierCompany | filterNormalValue}}</span>
            </div>
            <div class="cell">
              <span>快递单号</span>
              <span>{{item.courierNo | filterNormalValue}}</span>
            </div>
          </template>
        </div>
        <div class="group">
          <div class="title">收货信息</div>
          <div class="cell">
            <span>联系人</span>
            <span>{{item.consignee | filterNormalValue}}</span>
          </div>
          <div class="cell">
            <span>联系方式</span>
            <span>{{item.consigneePeople | filterNormalValue}}</span>
          </div>
          <div class="cell">
            <span>地址</span>
            <span>{{item.consigneeAddress | filterNormalValue}}</span>
          </div>
        </div>
      </div>
    </list>

    <div class="btn-group">
      <van-button class="btn" type="info" @click="toGameEditAddressPage">编辑收货信息</van-button>
    </div>
  </div>
</template>

<script>
import { loadMore } from '@/mixins/loadMore';
import dateFormat from '@/utils/dateFormat';
import { puzzle } from '@/api/game';
import list from '@/components/list/defaultList.vue'
export default {
  name: 'rewardLogList',
  data() {
    return {
      listAjax:  puzzle.prizeList,
      dateFormat,
      dataList: []
    };
  },
  filters: {
    filterNormalValue(value) {
      return value || '-';
    }
  },
  mixins: [loadMore],
  components:{list},
  methods: {
    toGameEditAddressPage() {
      this.$router.push({
        name: 'gameEditAddress'
      });
    },
 
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.reward-log-list {
  border-top: 0.11rem solid #f2f2f2;
  padding-bottom: 2rem;
  .item {
    border-bottom: 0.32rem solid #f2f2f2;
    .reward-name {
      font-size: 0.43rem;
      font-weight: bold;
      color: #323235;
      line-height: 1;
      padding: 0.53rem 0.43rem;
    }
    .group {
      padding: 0.1rem 0;
      border-top: 1px solid #e8e9ec;
      & > .title {
        font-size: 0.43rem;
        // font-weight: bold;
        color: #323235;
        line-height: 1;
        display: flex;
        padding-left: 0.43rem;
        padding-top: 0.4rem;
        padding-bottom: 0.2rem;
        &::before {
          content: '';
          margin-right: 0.11rem;
          display: block;
          width: 0.16rem;
          height: 0.43rem;
          background: #3667ec;
          border-radius: 0.1rem;
        }
      }
      .cell {
        padding: 0.33rem 0.43rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          line-height: 1;
          font-size: 0.43rem;
          line-height: 1;
          &:first-child {
            color: #6b6c6f;
          }
          &:last-child {
            color: #323235;
            text-align: right;
            width: 6.5rem;
            line-height: 0.67rem;
          }
        }
      }
    }
  }
  .btn-group {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2.13rem;
    background: #ffffff;
    border-top: 1px solid #dbdde2;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      width: 8.93rem;
      height: 1.28rem;
      border-radius: 0.21rem;
      font-size: 0.48rem;
    }
  }
}
</style>